import './Tray.scss';
import { Dispatch, ReactNode, SetStateAction, useMemo } from 'react';
import { MdClose } from 'react-icons/md';
import { Appearance, Design } from '../designConstants';
import { IconButton } from '../IconButton';
import { VideoContainer } from './VideoContainer';
import { VideoInfo } from './videoTutorialUtils';

interface TrayProps {
  videoList?: VideoInfo[] | undefined;
  setShowExpandedTray: Dispatch<SetStateAction<boolean>>;
}

export const Tray = ({ videoList, setShowExpandedTray }: TrayProps): ReactNode => {
  const videoContainers: ReactNode = useMemo(() => {
    if (!videoList || videoList.length === 0) {
      return <p>No videos available</p>;
    }

    return (
      <>
        {videoList.map(video => (
          <VideoContainer key={video.title} videoContent={video} />
        ))}
      </>
    );
  }, [videoList]);

  return (
    <div className='tray-container'>
      <div className='tray-header'>
        <div className='tray-text-and-button'>
          <div className='tray-text'>Help Center</div>
          <div className='widget-box'>
            <IconButton
              className='tray-close-button'
              appearance={Appearance.EMPTY}
              design={Design.NEUTRAL}
              onClick={() => setShowExpandedTray(false)}
            >
              <MdClose />
            </IconButton>
          </div>
        </div>
      </div>
      <div className='tray-body'>{videoContainers}</div>
    </div>
  );
};
